import React, { useContext, useState } from "react";

import { AuthContext } from "../providers/AuthProvider";
import { useAddPrimary } from "../customHooks/useAddPrimary";
import { SlidersContext } from "../providers/SlidersProvider";
import ContactCard from "./ContactCard";
import IncomingCallForm from "./IncomingCallForm";
import {
  JobsheetsContext,
  QuotesContext,
  TimesheetsContext,
} from "../providers";
import {
  useEditMode,
  useGlobalSearchData,
  useSectionedData,
} from "../customHooks";
import Loading from "./Loading";

function ContactsList({
  // primaries,
  // isMarked,
  // editPrimary,
  // inEditMode,
  phoneNumber,
}) {
  const auth = useContext(AuthContext);
  const addPrimary = useAddPrimary();
  const { setSliderId } = useContext(SlidersContext);

  // Pull in primaries data
  const { timesheets, loading } = useContext(TimesheetsContext);
  const { timesheets: jobsheets } = useContext(JobsheetsContext);
  const { timesheets: quotes } = useContext(QuotesContext);

  // Initialise sort and filter options

  const [sortAndFilterOptions, setSortAndFilterOptions] = useState({
    searchTerm: phoneNumber,
    sortBy: "refNumber", // Options: refNumber, jobReceived, created
    customerFilter: "all",
    jobStatusFilter: "all",
    //      window?.sessionStorage?.getItem("timesheets_jStatus") || "all",
    statusFilter: "all",
    //      window?.sessionStorage?.getItem("timesheets_statusFilter") || "all",
    quarterFilter: "all",
    order: true,
    primaryType: "timesheets",
  });

  const sectionedTimesheets = useSectionedData(
    timesheets,
    sortAndFilterOptions
  );

  // Global search data >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let isSearching = sortAndFilterOptions?.searchTerm.length > 0;
  const globalSearchData = useGlobalSearchData(
    jobsheets,
    quotes,
    sortAndFilterOptions,
    isSearching
  );

  let showGlobalSearch = isSearching && globalSearchData.length > 0;
  // console.log("global search data", globalSearchData);
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

  // Show footer conditions >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let showFooter = true;

  // // if (sliders && window.sessionStorage.getItem("currentPrimary")) {
  // if (sliders && sliderId) {
  //   showFooter = false;
  // }
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

  let combinedPrimariesData = globalSearchData
    .concat(...sectionedTimesheets.map((section) => section.data))
    .sort(
      (a, b) =>
        new Date(b.jobReceived).getTime() - new Date(a.jobReceived).getTime()
    );

  if (!phoneNumber) {
    combinedPrimariesData = [];
  }

  // Edit Mode Stuff >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  const {
    inEditMode,
    toggleEditMode,
    isMarked,
    markMonth,
    markItem,
    markedItems,
    editMarkedItems,
  } = useEditMode();

  function editContact(timesheet) {
    let timesheetId = timesheet.uid;

    if (inEditMode) {
      markItem(timesheet);
    } else {
      // Do nothing if click on contact when dit mode is not on.
      // if (sliders) {
      //   // If sliders are on, add chosen primary id to session storage
      //   setSliderId(timesheetId);
      // }
      // history.push(`/timesheet/${timesheetId}`, { timesheet });
    }
  }

  let showBin = inEditMode && markedItems.length > 0;

  // Edit Mode Stuff <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

  async function addAsJobsheet(data) {
    // console.log("customer data", data);
    // console.log("auth user", auth.user);
    let customerDetails = {
      authorisedBy: data["authorisedBy"] ?? "",
      address: data["address"] ?? "",
      address2: data["address2"] ?? "",
      email: data["email"] ?? "",
      city: data["city"] ?? "Glasgow",
      flat: data["flat"] ?? "",
      number: data["number"] ?? "",
      postcode: data["postcode"] ?? "",
      jobDetails: data["jobDetails"] ?? "",
      unit: data["unit"] ?? "",
      homeNumber: data["homeNumber"] ?? "",
    };

    // console.log("Auth user: ", auth.user);
    const result = await addPrimary("jobsheet", auth.user.uid, customerDetails);
    if (result.success) {
      setSliderId(result?.uid);
      // Can use error result to show meaningful error to user.
    }
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="contactList">
      {combinedPrimariesData.length > 0 ? (
        <>
          {combinedPrimariesData.map((data) => {
            return (
              <ContactCard
                key={data.uid}
                addAsJobsheet={addAsJobsheet}
                editPrimary={editContact}
                data={data}
                isMarked={isMarked}
                inEditMode={inEditMode}
              />
            );
          })}{" "}
        </>
      ) : (
        <IncomingCallForm
          phoneNumber={phoneNumber}
          addAsJobsheet={addAsJobsheet}
        />
      )}
    </div>
  );
}

export default ContactsList;
